<template>
  <div>
    <el-page-header @back="goBack" content="秒杀药品管理"> </el-page-header>
    <el-card style="width: 1400px; margin: 30px auto 0">
      <el-row :gutter="20">
        <el-col :span="5">
          <el-input
            v-model="ypmc"
            placeholder="请输入药品名称"
            size="medium"
            clearable
            @keyup.enter.native="getSeckillDrug"
          ></el-input>
        </el-col>
        <el-col :span="5">
          <el-input
            v-model="cdmc"
            placeholder="请输入产地名称"
            size="medium"
            clearable
            @keyup.enter.native="getSeckillDrug"
          ></el-input>
        </el-col>
        <el-col :span="5">
          <el-input
            v-model="gg"
            placeholder="请输入药品规格"
            size="medium"
            clearable
            @keyup.enter.native="getSeckillDrug"
          ></el-input>
        </el-col>
        <el-col :span="1.5">
          <el-button type="primary" size="medium" @click="getSeckillDrug"
            >查询</el-button
          >
        </el-col>
        <el-col :span="1.5">
          <el-button type="success" size="medium" @click="addSeckillDrug"
            >添加秒杀药品</el-button
          >
        </el-col>
        <el-col :span="1.5">
          <el-button type="danger" size="medium" @click="deleteChiose"
            >选中删除</el-button
          >
        </el-col>
      </el-row>
      <el-table
        :data="dataSeckillDrug"
        style="width: 100%; margin-top: 20px"
        border
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" align="center"> </el-table-column>
        <el-table-column label="药品图片" width="105" align="center">
          <template slot-scope="scope">
            <el-popover placement="right" width="245" trigger="hover">
              <img
                :src="base + scope.row.image"
                alt="图片加载错误"
                style="width: 220px; height: 220px"
              />
              <img
                slot="reference"
                :src="base + scope.row.image"
                alt="图片加载错误"
                style="width: 80px; height: 80px"
              />
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="ypmc" label="药品名称"> </el-table-column>
        <el-table-column prop="cdmc" label="产地名称"> </el-table-column>
        <el-table-column prop="gg" label="规格" align="center" width="120">
        </el-table-column>
        <el-table-column prop="dj" label="单价" align="center" width="70">
        </el-table-column>
        <el-table-column prop="msdj" label="秒杀单价" align="center" width="80">
        </el-table-column>
        <el-table-column prop="num" label="限购数量" align="center" width="80">
        </el-table-column>
        <el-table-column prop="sl" label="库存" align="center" width="80">
          <template slot-scope="scope">
            <span :style="scope.row.sl<100?'color:red;':''">{{scope.row.sl}}</span>
          </template>
        </el-table-column>
        <el-table-column label="是否上架" width="80" align="center">
          <template slot-scope="scope">
            <div>
              <el-switch
                v-model="scope.row.state"
                active-color="#13ce66"
                inactive-color="#ff4949"
                :active-value="1"
                :inactive-value="0"
                @change="changeState(scope.row)"
              >
              </el-switch>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="topindex" label="置顶数" width="70" align="center">
        </el-table-column>
        <el-table-column prop="yxq" label="有效期" width="90" align="center">
        </el-table-column>
        <el-table-column prop="dw" label="单位" width="60" align="center">
        </el-table-column>
        <el-table-column prop="pzwh" label="批准文号" align="center">
        </el-table-column>
        <el-table-column label="操作" align="center" width="210">
          <template slot-scope="scope">
            <el-button
              type="success"
              size="mini"
              @click="handleTop(scope.row)"
            >置顶</el-button>
            <el-button
              type="primary"
              size="mini"
              icon="el-icon-edit"
              @click="handleEdit(scope.row)"
            ></el-button>
            <el-button
              type="danger"
              size="mini"
              icon="el-icon-delete"
              @click="handleDelete(scope.row)"
            ></el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="SizeChange"
        @current-change="CurrentChange"
        :current-page="pageIndex"
        :page-sizes="[10, 20]"
        :page-size="pageSize"
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>
    <el-dialog
      :title="isAdd ? '添加秒杀药品' : '修改秒杀药品'"
      :visible.sync="dialogSeckillDrug"
      :width="'900px'"
      :close-on-click-modal="false"
    >
      <el-form :model="formSeckillDrug" label-width="100px">
        <el-form-item label="药品名称：">
          <el-input
            v-model="formSeckillDrug.ypmc"
            style="width: 60%"
            disabled
          ></el-input>
          <el-button
            type="success"
            style="margin-left: 30px"
            v-if="isAdd"
            @click="chioseDrug"
            >选择药品</el-button
          >
        </el-form-item>
        <el-form-item label="产地名称：">
          <el-input v-model="formSeckillDrug.cdmc" disabled></el-input>
        </el-form-item>
        <el-form-item label="规格：">
          <el-input v-model="formSeckillDrug.gg" disabled></el-input>
        </el-form-item>
        <el-form-item label="批准文号：">
          <el-input v-model="formSeckillDrug.pzwh" disabled></el-input>
        </el-form-item>
        <el-form-item label="库存：" v-if="isAdd">
          <el-input v-model="formSeckillDrug.sl" disabled></el-input>
        </el-form-item>
        <el-form-item label="单价：">
          <el-input v-model="formSeckillDrug.dj" disabled></el-input>
        </el-form-item>
        <el-form-item label="秒杀单价：" class="is-required">
          <el-input v-model="formSeckillDrug.msdj"></el-input>
        </el-form-item>
        <el-form-item label="限购数量：" class="is-required">
          <el-input v-model.number="formSeckillDrug.num"></el-input>
        </el-form-item>
        <el-form-item label="是否上架：" class="is-required">
          <el-radio-group v-model="formSeckillDrug.state">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="上传图片：" class="is-required">
          <el-upload
            action=""
            list-type="picture-card"
            :limit="1"
            :file-list="fileList"
            :on-exceed="handleExceed"
            :on-remove="handleRemove"
            :http-request="uploadFile"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogSeckillDrug = false">取 消</el-button>
        <el-button type="primary" @click="submitUp">确 定</el-button>
      </div>
      <el-dialog
        title="选择秒杀药品"
        :visible.sync="dialogDrug"
        :width="'1300px'"
        :close-on-click-modal="false"
        append-to-body
        center
      >
        <div>
          <el-row :gutter="20">
            <el-col :span="5">
              <el-input
                v-model="Dypmc"
                placeholder="请输入药品名称"
                size="medium"
                clearable
                @keyup.enter.native="getDrug"
              ></el-input>
            </el-col>
            <el-col :span="5">
              <el-input
                v-model="Dcdmc"
                placeholder="请输入产地名称"
                size="medium"
                clearable
                @keyup.enter.native="getDrug"
              ></el-input>
            </el-col>
            <el-col :span="5">
              <el-input
                v-model="Dgg"
                placeholder="请输入药品规格"
                size="medium"
                clearable
                @keyup.enter.native="getDrug"
              ></el-input>
            </el-col>
            <el-col :span="1.5">
              <el-button type="primary" size="medium" @click="getDrug"
                >查询</el-button
              >
            </el-col>
          </el-row>
          <el-table
            :data="dataDrug"
            style="width: 100%; margin-top: 20px"
            border
          >
            <el-table-column prop="ypmc" label="药品名称" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="cdmc" label="产地名称" show-overflow-tooltip>
            </el-table-column>
            <el-table-column
              prop="gg"
              label="药品规格"
              align="center"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column prop="boss" label="BOSS号" align="center" width="80">
            </el-table-column>
            <el-table-column prop="dj" label="单价" align="center" width="80">
            </el-table-column>
            <el-table-column prop="sl" label="库存" align="center" width="80">
            </el-table-column>
            <el-table-column
              prop="zbz"
              label="中包装"
              align="center"
              width="80"
            >
            </el-table-column>
            <el-table-column prop="bz" label="包装" align="center" width="80">
            </el-table-column>
            <el-table-column
              prop="isretail"
              label="零/整"
              align="center"
              width="80"
            >
              <template slot-scope="scope">
                <div>
                  {{ scope.row.isretail ? "零" : "整" }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="scrq"
              label="生产日期"
              align="center"
              width="90"
            >
            </el-table-column>
            <el-table-column
              prop="yxq"
              label="有效期"
              align="center"
              width="90"
            >
            </el-table-column>
            <el-table-column prop="pzwh" label="批准文号" show-overflow-tooltip>
            </el-table-column>
            <el-table-column align="center" label="操作" width="80">
              <template slot-scope="scope">
                <el-button
                  type="success"
                  size="mini"
                  @click="determine(scope.row)"
                  >选择</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="drugSizeChange"
            @current-change="drugCurrentChange"
            :current-page="DrugIndex"
            :page-sizes="[10, 20]"
            :page-size="DrugSize"
            background
            layout="total, sizes, prev, pager, next, jumper"
            :total="DrugTotal"
          >
          </el-pagination>
        </div>
        <div slot="footer">
          <el-button @click="dialogDrug = false">取 消</el-button>
          <el-button type="primary" @click="dialogDrug = false"
            >确 定</el-button
          >
        </div>
      </el-dialog>
    </el-dialog>
    <el-dialog
      title="修改置顶数"
      :visible.sync="dialogTop"
      :width="'500px'"
      center
      :close-on-click-modal="false">
      <div>
        <el-form :model="formTop" label-width="100px">
          <el-form-item label="置顶数：" class="is-required">
            <el-input v-model="formTop.topindex"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <el-button @click="dialogTop = false">取 消</el-button>
        <el-button type="primary" @click="submitTop">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      msid: 0,
      ypmc: "",
      cdmc: "",
      gg: "",
      base: "http://fw.hyey.cn",
      pageIndex: 1,
      pageSize: 20,
      total: 0,
      dataSeckillDrug: [],
      isAdd: true,
      dialogSeckillDrug: false,
      formSeckillDrug: {
        ypmc: "",
        cdmc: "",
        gg: "",
        pzwh: "",
        drugid: "",
        msid: 0,
        state: 0,
        dj: 0,
        sl: 0,
        msdj: 0,
        num: 0,
        image: "",
      },
      initForm: {},
      fileList: [],
      dialogDrug: false,
      Dypmc: "",
      Dcdmc: "",
      Dgg: "",
      DrugIndex: 1,
      DrugSize: 20,
      DrugTotal: 0,
      dataDrug: [],
      multipleSelection: [],
      dialogTop:false,
      formTop:{
        id:0,
        topindex:0,
      }
    };
  },
  mounted() {
    this.msid = this.$route.params.msid;
    this.initForm = { ...this.formSeckillDrug };
    this.getSeckillDrug();
  },
  methods: {
    goBack() {
      this.$router.back();
    },
    getSeckillDrug() {
      this.pageIndex = 1;
      this.searchSeckillDrug();
    },
    searchSeckillDrug() {
      if(!this.msid){
        setTimeout(()=>{
          this.goBack();
        },1000)
      }else{
        this.$http
        .post("DsApi/GetSearchList", {
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          keys: this.ypmc,
          cdmc: this.cdmc,
          gg: this.gg,
          action: "msdrug",
          id: this.msid,
        })
        .then((res) => {
          if (res.data.isok) {
            // 
            this.dataSeckillDrug = res.data.data;
            this.total = res.data.recount;
          }
        });
      } 
    },
    changeState(rows) {
      this.$http
        .post("DsApi/UpdownMsDrug", {
          id: rows.id,
          state: rows.state,
          drugid: rows.drugid,
        })
        .then((res) => {
          if (res.data.isok) {
            this.$message.success(res.data.message);
            this.searchSeckillDrug();
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
    addSeckillDrug() {
      this.isAdd = true;
      this.formSeckillDrug = { ...this.initForm };
      this.fileList = [];
      this.dialogSeckillDrug = true;
    },
    submitUp() {
      this.formSeckillDrug.msid = this.msid;
      if (this.isAdd) {
        if(this.formSeckillDrug.drugid){
          this.$message.warning("对不起，请您先选择要添加的药品！")
        }else if(this.formSeckillDrug.msdj){
          this.$message.warning("对不起，秒杀单价不能为0！")
        }else if(this.formSeckillDrug.num){
          this.$message.warning("对不起，限购数量不能为0！")
        }
        this.$http.post("DsApi/AddMsDrug", this.formSeckillDrug).then((res) => {
          if (res.data.isok) {
            this.$message.success(res.data.message);
            this.dialogSeckillDrug = false;
            this.searchSeckillDrug();
          } else {
            this.$message.error(res.data.message);
          }
        });
      } else {
        this.$http
          .post("DsApi/UpdateMsDrug", this.formSeckillDrug)
          .then((res) => {
            if (res.data.isok) {
              this.$message.success(res.data.message);
              this.dialogSeckillDrug = false;
              this.searchSeckillDrug();
            } else {
              this.$message.error(res.data.message);
            }
          });
      }
    },
    handleEdit(rows) {
      this.formSeckillDrug = { ...this.initForm };
      this.fileList=[];
      this.isAdd = false;
      this.formSeckillDrug.ypmc = rows.ypmc;
      this.formSeckillDrug.cdmc = rows.cdmc;
      this.formSeckillDrug.gg = rows.gg;
      this.formSeckillDrug.pzwh = rows.pzwh;
      this.formSeckillDrug.dj = rows.dj;
      this.formSeckillDrug.drugid = rows.drugid;
      this.formSeckillDrug.state = rows.state;
      this.formSeckillDrug.msdj = rows.msdj;
      this.formSeckillDrug.num = rows.num;
      this.formSeckillDrug.image = rows.image;
      this.formSeckillDrug.id = rows.id;
      if(rows.image){
        this.fileList=[];
        let images = { url: this.base+rows.image };
        this.fileList.push(images);
      }else{
        this.fileList=[]
      }
      this.dialogSeckillDrug = true;
    },
    handleTop(rows){
      this.formTop.id=rows.id;
      this.formTop.topindex=rows.topindex;
      this.dialogTop=true;
    },
    submitTop(){
      this.$http.post("DsApi/UpdateMSDrugIndex",this.formTop).then(res=>{
        if(res.data.isok){
          this.$message.success(res.data.message);
          this.searchSeckillDrug();
          this.dialogTop=false;
        }else{
          this.$message.error(res.data.message);
        }
      })
    },
    //当多选框被选择时
    handleSelectionChange(val) {
      this.multipleSelection = val.map((item) => {
        return item.id;
      });
    },
    handleDelete(rows) {
      this.$confirm("此操作将会永久删除这个秒杀药品, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.DelMsDrug(rows.id + "");
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    //删除选中
    deleteChiose() {
      if (this.multipleSelection.length == 0) {
        this.$message.error("对不起，您还未选中秒杀药品！");
      } else {
        let id = this.multipleSelection.join();
        this.$confirm("此操作将永久删除这些秒杀药品, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.DelMsDrug(id);
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      }
    },
    //上传图片
    uploadFile(params) {
      const file = params.file,
        fileType = file.type,
        isImage = fileType.indexOf("image") != -1;
      if (!isImage) {
        this.$message.error("只能上传图片格式png、jpg、gif!");
        return;
      }
      let param = new FormData(); // 创建form对象
      param.append("imgFile", file); //对应后台接收图片名
      param.append("username", window.sessionStorage.getItem("username"));
      param.append("tokenid", window.sessionStorage.getItem("tokenid"));
      param.append("phone_uuid", window.sessionStorage.getItem("phone_uuid"));
      this.$http
        .post("Dls/UpLoadImage", param, {
          headers: {
            "Content-Type":
              "multipart/form-data;boundary =" + new Date().getTime(),
          },
        })
        .then((res) => {
          //
          if (res.data.isok) {
            this.$message({
              type: "success",
              message: "上传成功!",
            });
            //
            this.formSeckillDrug.image = res.data.data;
          } else {
            this.$message.error(res.data.message);
            this.fileList = [];
          }
        });
    },
    //移除图片给提示
    handleRemove() {
      this.$message.error("图片已移除，请重新上传！");
      this.formSeckillDrug.image=""
    },
    // 限制上传个数
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择1张图片，本次选择了 ${files.length} 张图片，共选择了 ${
          files.length + fileList.length
        } 张图片`
      );
    },
    chioseDrug() {
      this.dialogDrug = true;
      this.getDrug();
    },
    getDrug() {
      this.DrugIndex = 1;
      this.searchDrug();
    },
    searchDrug() {
      this.$http
        .post("DsApi/GetSearchList", {
          pageIndex: this.DrugIndex,
          pageSize: this.DrugSize,
          keys: this.Dypmc,
          cdmc: this.Dcdmc,
          gg: this.Dgg,
          action: "alldrug",
        })
        .then((res) => {
          // 
          if (res.data.isok) {
            this.dataDrug = res.data.data;
            this.DrugTotal = res.data.recount;
          }
        });
    },
    determine(rows) {
      this.formSeckillDrug.drugid = rows.id;
      this.formSeckillDrug.ypmc = rows.ypmc;
      this.formSeckillDrug.cdmc = rows.cdmc;
      this.formSeckillDrug.gg = rows.gg;
      this.formSeckillDrug.pzwh = rows.pzwh;
      this.formSeckillDrug.dj = rows.dj;
      this.formSeckillDrug.sl = rows.sl;
      this.dialogDrug = false; 
    },
    //删除秒杀活动请求
    DelMsDrug(id) {
      this.$http
        .post("DsApi/DelMsDrug", {
          id,
        })
        .then((res) => {
          if (res.data.isok) {
            this.$message.success(res.data.message);
            this.searchSeckillDrug();
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
    // 所有药品Size发生改变时
    drugSizeChange(val) {
      this.DrugSize = val;
      this.searchDrug();
    },
    // 秒杀药品Size发生改变时
    SizeChange(val) {
      this.pageSize = val;
      this.searchSeckillDrug();
    },
    // 所有药品Index发生改变
    drugCurrentChange(val) {
      this.DrugIndex = val;
      this.searchDrug();
    },
    // 秒杀药品Size发生改变时
    CurrentChange(val) {
      this.pageIndex = val;
      this.searchSeckillDrug();
    },
  },
};
</script>

<style lang="less" scoped>
.el-page-header {
  margin-left: 30px;
  margin-top: 20px;
}
/deep/ .el-pagination {
  text-align: center;
  margin-top: 15px;
}
/deep/ .el-table th {
  background-color: #eef1f6;
}
/deep/ tr td {
  font-size: 12px;
}
</style>


// WEBPACK FOOTER //
// src/components/SeckillDrug.vue